import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import DatePicker, { registerLocale } from "react-datepicker";
import it from 'date-fns/locale/it';
import "react-datepicker/dist/react-datepicker.css";
import {
    errorRead,
    doRequest
} from '../../../actions';
import Error from '../../elements/Error';
import SchemaValidator from '../../../lib/SchemaValidator';
import { FormattedMessage, useIntl } from 'react-intl';

registerLocale('it', it)

const mapDispatchToProps = (dispatch) => ({
    errorRead: () => dispatch(errorRead()),
    doRequest: payload => dispatch(doRequest('signup', payload)),
});

const mapStateToProps = state => ({
    data: state.data,
    stateError: state.error,
    user: state.user
});

const _Signup = ({ data, errorRead, doRequest, stateError }) => {

    const initialPayload = {
        email: "",
        password: "",
        name: "",
        lastname: "",
        birth_date: "",
        newsletter: 0,
        privacy: 0,
    };
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 14);
    const [errors, setErrors] = useState("");
    const [processed, setProcessed] = useState(false);
    const [payload, setPayload] = useState(initialPayload);
    const [success, setSuccess] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const intl = useIntl();


    useEffect(
        () => {
            if (stateError) {
                setErrors(stateError);
                errorRead();
            }
            return () => null;
        },
        [errorRead, errors, setErrors, stateError]
    );

    const isDisabled = () => !(
        payload.email.length > 0
        &&
        payload.name.length > 0
        &&
        payload.lastname.length > 0
        &&
        payload.password.length >= 8
        &&
        payload.birth_date.length >= 8
        &&
        payload.privacy === 1
    );

    const handleChange = (e) => {
        let _payload = payload;
        if (e instanceof Date) {
            _payload.birth_date = new Date(e.getTime() - (e.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
            setSelectedDate(e);
        } else if (e.target.type === 'select-one') {
            _payload[e.target.name] = Number(e.target.value);
        } else if (e.target.type === 'checkbox') {
            _payload[e.target.name] = e.target.checked ? 1 : 0;
        } else {
            _payload[e.target.name] = e.target.value;
        }
        setPayload({
            ...payload,
            ..._payload,
        });
    };

    const handleSignup = (e) => {
        e.preventDefault();
        let v = SchemaValidator(payload, 'signup');
        if (payload.password !== payload.confirm_password) {
            setErrors(intl.formatMessage({ id: "App.info.LePasswordNonCoincidono" }));
        } else if (v.errors.length > 0) {
            if (v.errors.length > 0) {
                setErrors(v.errors.map(el => {
                    let x = el.instancePath.replace(/^\/+/, '')
                    return !!v.schema.properties[x].message === true ? v.schema.properties[x].message : null;
                }).filter(el => !!el).join("\n"));
            }
        } else {
            setProcessed(true);
            doRequest(payload);
        }
    }

    if (data && processed) {
        setErrors("");
        setProcessed(false);
        setSuccess(true);
    }

    return (
        <section>
            <div>
                <img className="mainLogo" src="/static/images/testalince.png" alt="Lince" title="Lince Clouding" />
            </div>
            <div>
                <form name="signup">
                    <fieldset>
                        {
                            success
                                ?
                                <div>
                                    <p>
                                        <strong><FormattedMessage id="App.info.RegistrazioneCompletata" /></strong>
                                        <br />
                                        <FormattedMessage id="App.info.success2" values={{userEmail: payload.email}} />
                                    </p>
                                    <p>
                                        <FormattedMessage id="App.info.warning" />
                                    </p>
                                </div>
                                :
                                <>
                                    <p>
                                        <input type="email" placeholder={intl.formatMessage({ id: 'App.info.inputEmail' })} name="email" onChange={handleChange} />
                                    </p>
                                    <p>
                                        <input type="text" placeholder={intl.formatMessage({ id: "App.info.inputFirstName" })} name="name" onChange={handleChange} />
                                    </p>
                                    <p>
                                        <input type="text" placeholder={intl.formatMessage({ id: "App.info.inputLastName" })} name="lastname" onChange={handleChange} />
                                    </p>
                                    <DatePicker
                                        dateFormat={intl.formatMessage({ id: "App.info.FormatDate" })}
                                        locale="it"
                                        maxDate={maxDate}
                                        startDate={maxDate}
                                        onChange={handleChange}
                                        onSelect={handleChange}
                                        selected={selectedDate}
                                        showYearDropdown={true}
                                        placeholderText={intl.formatMessage({ id: "App.info.inputDateBirth" })}
                                    />
                                    <p>
                                        <input type="password" placeholder={intl.formatMessage({ id: "App.info.InserirePassword" })} name="password" onChange={handleChange} />
                                        <br />
                                        <small><FormattedMessage id="App.info.MinimoOttoCaratteri" /></small>
                                    </p>
                                    <p>
                                        <input type="password" placeholder={intl.formatMessage({ id: "App.info.ConfermarePassword" })} name="confirm_password" onChange={handleChange} />
                                    </p>
                                    <p>
                                        <strong><FormattedMessage id="App.info.PrivacyPolicy" /></strong>
                                    </p>
                                    <p>
                                        <textarea rows="7" readOnly={'readonly'} defaultValue={`INFORMATIVA PRIVACY ai sensi dell’art. 13 del Codice della Privacy e del Regolamento UE 679/16. Nel rispetto degli articoli 4 e 28 del decreto legislativo 30 Giugno 2003, n. 196 - Codice della privacy - e degli articoli 4, 7, e 24 del Regolamento UE 2016/679 del 27 aprile 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, La informiamo che  LINCE ITALIA S.p.A. intende acquisire o già detiene dati personali che la riguardano, eventualmente anche sensibili e/o giudiziari, al fine di fornire servizi da lei richiesti o in Suo favore previsti. Per trattamento di dati personali intendiamo qualsiasi operazione o insieme di operazioni, compiute con o senza l'ausilio di processi automatizzati e applicate a dati personali o insiemi di dati personali, come la raccolta, la registrazione, l'organizzazione, la strutturazione, la conservazione, l'adattamento o la modifica, l'estrazione, la consultazione, l'uso, la comunicazione mediante trasmissione, diffusione o qualsiasi altra forma di messa a disposizione, il raffronto o l'interconnessione, la limitazione, la cancellazione o la distruzione. I dati forniti da Lei o da altri soggetti, sono solo quelli strettamente necessari per fornirLe i servizi sopra citati e sono trattati solo con le modalità e le procedure - effettuate anche con l’ausilio di strumenti elettronici - necessari a questi scopi. I suoi dati possono essere conosciuti dai nostri collaboratori specificatamente autorizzati a trattare tali dati, in qualità di responsabili o incaricati per il perseguimento delle finalità sopraindicate. I suoi dati non sono soggetti a diffusione. senza i suoi dati, alcuni dei quali ci debbono essere forniti da Lei o da terzi per obbligo di legge, non potremmo fornirle i nostri servizi in tutto o in parte. Lei ha diritto di conoscere, in ogni momento, quali sono i suoi dati presso di noi, la loro origine e come vengono utilizzati, ha inoltre il diritto di farli aggiornare, rettificare, integrare o cancellare, chiederne il blocco e opporsi al loro trattamento. I dati personali raccolti per le finalità sopra precisate potrebbero essere altresì trattati (unitamente ad altre informazioni di contatto aggiuntive e facoltative, come indirizzi email, numeri di utenza cellulare, indirizzi geografici) sia in modalità cartacea (es: compilazione di moduli, coupon e similari cartacei) che con modalità automatizzata/informatica (per esempio mediante newsletter), per il perseguimento di finalità promozionali, pubblicitarie, di marketing e ricerche di mercato. I dati saranno conservati per i tempi definiti dalla normativa di riferimento, che di seguito si specificano ai sensi dell’art. 13, comma 2, lettera (a) del Regolamento UE. Restano inoltre fermi i termini quinquennali o decennali di conservazione dei soli documenti e relativi dati di natura civilistica, contabile e fiscale come previsti dalle leggi in vigore. Ai sensi dell’articolo 7 del Codice della privacy e ai sensi degli articoli 13, comma 2, lettere (b) e (d), 15, 18, 19 e 21 del Regolamento UE, si informa l’interessato che: A.egli ha il diritto di chiedere al Titolare del trattamento l'accesso ai dati personali, la rettifica o la cancellazione degli stessi o la limitazione del trattamento che lo riguardano o di opporsi al loro trattamento, oltre al diritto alla portabilità dei dati; B.egli ha il diritto di proporre un reclamo al Garante per la protezione dei dati personali, seguendo le procedure e le indicazioni pubblicate sul sito web ufficiale dell’Autorità su www.garanteprivacy.it;  C.le eventuali rettifiche o cancellazioni o limitazioni del trattamento effettuate su richiesta dell’interessato - salvo che ciò si riveli impossibile o implichi uno sforzo sproporzionato – saranno comunicate dal Titolare del trattamento a ciascuno dei destinatari cui sono stati trasmessi i dati personali. Il Titolare del trattamento potrà comunica all'interessato tali destinatari qualora l'interessato lo richieda.  L’esercizio dei diritti non è soggetto ad alcun vincolo di forma ed è gratuito. Titolare del trattamento è la Società che si avvale di responsabili; responsabile designato per il riscontro all’interessato in caso di esercizio dei diritti ex art. 7 del d.lgs.196/2003 è Mauro Mercuri. Ogni informazione in merito agli oggetti o alle categorie di soggetti cui vengono comunicati i dati o che possono venirne a conoscenza in qualità di responsabili o incaricati preposti ai trattamenti sopraindicati può essere richiesta alla citata responsabile. Sulla base di quanto sopra, selezionando il checkbox relativo alla privacy, Lei può esprimere il consenso al trattamento dei dati - eventualmente anche sensibili - effettuato dalla società, alla loro comunicazione ai soggetti sopraindicati e al trattamento da parte di questi ultimi. LINCE ITALIA S.P.A.`} />
                                    </p>
                                    <p>
                                        <small>
                                            <FormattedMessage id="App.info.sub1" />
                                        </small>
                                    </p>
                                    <p>
                                        <input type="checkbox" id="privacy" defaultValue="0" placeholder={intl.formatMessage({ id: "App.info.EsprimiScelta" })} name="privacy" onChange={handleChange} />
                                        <label htmlFor={`privacy`}>
                                            <span />
                                            <FormattedMessage id="App.info.Submit" />
                                        </label>
                                    </p>
                                    <p>
                                        <small>
                                            <FormattedMessage id="App.info.sub2" />
                                        </small>
                                    </p>
                                    <p>
                                        <input type="checkbox" defaultValue="0" id="newsletter" name="newsletter" onChange={handleChange} />
                                        <label htmlFor={`newsletter`}>
                                            <span />
                                            <FormattedMessage id="App.info.Submit" />
                                        </label>
                                    </p>
                                    <Error text={errors} />
                                    <p>
                                        <button disabled={isDisabled()} className="ok" onClick={handleSignup}>
                                            <FormattedMessage id="App.info.Register" />
                                        </button>
                                    </p>
                                    <p className="sameLine" style={{ marginBottom: "6em" }}>
                                        <small>
                                            <span>
                                                <i className="warning fa fa-exclamation-triangle"></i>
                                                <FormattedMessage id="App.info.warning3" />
                                                <br />
                                                <FormattedMessage id="App.info.warning4" />
                                            </span>
                                        </small>
                                    </p>
                                </>
                        }
                    </fieldset>
                </form>
            </div>
        </section>
    );
};

const Signup = connect(mapStateToProps, mapDispatchToProps)(_Signup);

export default Signup;